import { faArrowDown, faArrowUp, faCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMemo } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { double, formatNumber } from "../../../formatters/number-formatter-functional";

export const ChangeBody = ({ rawData }) => {

    return useMemo(() => {
        <div className='changeBodyTemplate'>
            <Container >
                <Row className='changeBodyTemplate'>
                    <Col md='6' sm='6' className='p-r-25 p-l-0 p-t-0 p-b-0 text-align-right'>
                        {rawData.change >= 0 ? <FontAwesomeIcon icon={faArrowUp} /> : <FontAwesomeIcon icon={faArrowDown} />}
                    </Col>
                    <Col md='6' sm='6' className='p-0'>

                        {rawData.change &&
                            <Row >
                                % {rawData.change}
                            </Row>
                        }
                        {rawData.dailyChange &&
                            <Row >
                                % {(rawData.dailyChange).toFixed(2)}
                            </Row>
                        }
                    </Col>
                </Row>
            </Container>
        </div>
    }, [rawData.change])
};

export const DailyChangeBody = ({ rawData }) => {
   
    return useMemo(() => {
        console.log('DailyChangeBody USEMEMO', rawData.dailyChange)
      return  <div className='changeBodyTemplate'>
            <Container >
                <Row className='changeBodyTemplate'>
                    <Col md='6' sm='6' className='p-r-25 p-l-0 p-t-0 p-b-0 text-align-right'>
                        {rawData.dailyChangeColor == 'green' ? <FontAwesomeIcon icon={faArrowUp} />
                            : rawData.dailyChangeColor == 'red' ? < FontAwesomeIcon icon={faArrowDown} />
                                : <FontAwesomeIcon className='realTimeCircleIcon' icon={faCircle} />
                        }
                    </Col>
                    <Col md='6' sm='6' className='p-0'>
                        <Row >
                            {rawData.dailyChange == 0 &&
                                <label className='p-0'>
                                    {double(rawData.dailyChange)}
                                </label>
                            }
                            {rawData.dailyChange !== 0 &&
                                <label className='p-0'>
                                    % {double(rawData.dailyChange)}
                                </label>
                            }
                        </Row>
                    </Col>
                </Row>
            </Container>
        </div>
    }, [rawData.dailyChange])
}

export const DynamicBody = (props) => {
    return useMemo(() => {
      return  <Container className='numberBodyTemplateContainer'>
            <Row className='numberBodyTemplateRow'>
                <Col md='12' sm='12' className='p-0'>
                    <label className='p-0 numberBodyTemplateLabel'>
                        {double(props.data[props.field], 2)}
                    </label>
                </Col>
            </Row>
        </Container>
    }, [props.data, props.field])
};